<template>
  <div
    class="field RMPE-CustomField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <div class="control">
      <label
        class="label"
        :for="fieldQuestionId"
      >
        <span
          :class="{'RMPE-Required': question.required}"
          v-html="question.label"
        />
        <div class="input-container">
          <textarea
            :id="fieldQuestionId"
            ref="auto-focus-target"
            :value="fieldValue"
            :class="{ 'is-danger': fieldHasError }"
            type="text"
            class="input"
            autocomplete="no"
            @change="$emit('change', $event.target.value)"
            @blur="isBlurred = true"
          />
        </div>
      </label>
    </div>
    <ErrorMessage
      v-if="fieldHasError"
      :errors="error.errors"
      :is-blurred="isBlurred"
      :manual-validate="manualValidate"
    />
    <HintMessage
      v-else
      :hint="question.warningMessage"
    />
  </div>
</template>

<script>
import StaticFieldMixin from '../../mixins/static-field-mixin';
import TextareaFieldMixin from '../common/textarea-field';

export default {
  mixins: [StaticFieldMixin, TextareaFieldMixin],
};
</script>

<style scoped lang="scss">
textarea {
  min-height: 150px;
}
</style>
